module.exports = __webpack_public_path__ + "static/media/ixuanzhilogo.a6dcd6f3.png";